import { render, staticRenderFns } from "./departmentBannerDetail.vue?vue&type=template&id=3cc7b6ca&scoped=true"
import script from "./departmentBannerDetail.vue?vue&type=script&lang=js"
export * from "./departmentBannerDetail.vue?vue&type=script&lang=js"
import style0 from "./departmentBannerDetail.vue?vue&type=style&index=0&id=3cc7b6ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc7b6ca",
  null
  
)

export default component.exports